<template>
    <div class="sizex props-group">
        <!-- <el-form-item label="列数">
          <el-input type="number" v-model="component.position.sizex" min="1" max="4"/>
        </el-form-item> -->
    </div>
</template>

<script>
export default {
  name: 'attr-sizex',
  props: ['component'],
  inject: ['formService'],
  data () {
    return {

    }
  },
  methods: {
  }
}
</script>

<style>
  .sizex{
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/sizex.vue